import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { 
  IOpcionesResponse, 
  IOpcionesRequest 
} from '../interfaces/opciones.interface';

@Injectable({
  providedIn: 'root'
})
export class OpcionesService {
  private readonly API_URL = `${environment.apiNewBackBaseUrl}OpcionesSolicitud/GetActividad`;

  constructor(private http: HttpClient) { }

  getOpciones(request: IOpcionesRequest): Observable<IOpcionesResponse> {
    return this.http.post<IOpcionesResponse>(this.API_URL, request);
  }

  getTipoTelefono(): Observable<IOpcionesResponse> {
    const payload: IOpcionesRequest = {
      sTabla: 'telefon',
      sCampo: 'TipoTelefono'
    };
    return this.http.post<IOpcionesResponse>(this.API_URL, payload);
  }

  getBoletinado(): Observable<IOpcionesResponse> {
    const payload: IOpcionesRequest = {
      sTabla: 'telefon',
      sCampo: 'boletinado'
    };
    return this.http.post<IOpcionesResponse>(this.API_URL, payload);
  }
} 